export const properties = [
  {
    id: "wendel",
    name: "Domaine de Wendel",
    location: "Hayange (57240)",
    tag: "Monument Historique",
    description:
      "Ancien siège administratif des forges de Wendel, entouré de nature au cœur d'un quartier résidentiel. Le site sera aménagé en 125 logements, du studio au 4 pièces, dont certains en duplex.",
    facts: ["125 logements", "Studio au 4 pièces", "Belles hauteurs sous plafond"],
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/0068afa0-b7b6-4b90-b88e-c6415676b741.jpg",
  },
  {
    id: "montfleury",
    name: "Le Montfleury",
    location: "Cannes (06) · Avenue Beauséjour",
    tag: "Côte d'Azur",
    description:
      "Cannes, capitale du cinéma et de l'art de vivre. Une adresse résidentielle nichée sur les hauteurs, à quelques coups de rame des îles de Lérins, au cœur du golfe de la Napoule.",
    facts: ["Quartier Montfleury", "Proche des îles de Lérins", "Résidence de standing"],
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/7146a4c2-82b4-4fd7-8fa0-46178a25a44d.jpg",
  },
];
